import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ColoredLine from "../common/coloredLine";
import ContentCard from "../common/contentCard";
import { fetchHtmlPageByName } from "../../services/htmlPageService";

const PssfYear = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const [htmlContentFamilySupport, setHtmlContentFamilySupport] = useState("");
  const [htmlContentFamilyPreservation, setHtmlContentFamilyPreservation] =
    useState("");
  const [htmlContentFamilyReunification, setHtmlContentFamilyReunification] =
    useState("");
  const [htmlContentAdoptionPromotion, setHtmlContentAdoptionPromotion] =
    useState("");
  const [htmlContentTabSummary, setHtmlContentTabSummary] = useState("");

  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const [
          pssfyear,
          familySupport,
          familyPreservation,
          familyReunification,
          adoptionPromotion,
          summary,
        ] = await Promise.all([
          fetchHtmlPageByName("pssfyear"),
          fetchHtmlPageByName("pssfyear-FamilySupportModels"),
          fetchHtmlPageByName("pssfyear-FamilyPreservationModels"),
          fetchHtmlPageByName("pssfyear-FamilyReunificationModels"),
          fetchHtmlPageByName("pssfyear-AdoptionPromotionModels"),
          fetchHtmlPageByName("pssfyear-LowerTabSummary"),
        ]);

        setHtmlContent(pssfyear.data.content);
        setHtmlContentFamilySupport(familySupport.data.content);
        setHtmlContentFamilyPreservation(familyPreservation.data.content);
        setHtmlContentFamilyReunification(familyReunification.data.content);
        setHtmlContentAdoptionPromotion(adoptionPromotion.data.content);
        setHtmlContentTabSummary(summary.data.content);
      } catch (error) {
        console.error("Error fetching HTML page content:", error);
        setError("Failed to load content");
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  const onTabChange = (e, ElementId) => {
    const x = document.getElementsByClassName("category");
    Array.from(x).forEach((element) => {
      element.classList.add("d-none");
    });

    const tab = document.getElementById(ElementId);
    tab.classList.remove("d-none");

    const tablinks = document.getElementsByClassName("tab-link");
    Array.from(tablinks).forEach((link) => {
      link.classList.remove("tabbeddiv-custom-blue", "tabbeddiv-custom");
    });

    document.getElementById("tab" + e).classList.add("tabbeddiv-custom-blue");
  };

  if (loading) return <div>Loading...</div>; // Display loading indicator
  if (error) return <div>{error}</div>; // Display error message if any

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-10">
          <div className="row col mt-5 mb-5">
            <div className="row">
              <div className="col">
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
              </div>
            </div>
          </div>
          <div className="row mt-4"></div>

          <div className="row mt-4">
            <div dangerouslySetInnerHTML={{ __html: htmlContentTabSummary }} />
          </div>
          <nav
            className="navbar navbar-expand-lg tabbedNavbar-custom"
            style={{ padding: 0 }}
          >
            <div className="collapse navbar-collapse">
              <div
                className="navbar-nav nav-fill w-100"
                style={{ height: "60px" }}
              >
                <div
                  id="tab1"
                  className="nav-item nav-link tab-link border-end border-white col-3 tabbeddiv-custom-blue"
                  onClick={() => onTabChange(1, "support")}
                >
                  Family Support Service Models
                </div>
                <div
                  id="tab2"
                  className="nav-item nav-link tab-link border-end border-white col-3 tabbeddiv-custom"
                  onClick={() => onTabChange(2, "preservation")}
                >
                  Family Preservation Service Models
                </div>
                <div
                  id="tab3"
                  className="nav-item nav-link tab-link border-end border-white col-3 tabbeddiv-custom"
                  onClick={() => onTabChange(3, "reunification")}
                >
                  Family Reunification Models
                </div>
                <div
                  id="tab4"
                  className="nav-item nav-link tab-link col-3 tabbeddiv-custom"
                  onClick={() => onTabChange(4, "permanency")}
                >
                  Adoption Promotion and Post-Permanency Support Models
                </div>
              </div>
            </div>
          </nav>
          <div
            id="support"
            className="card category p-2"
            style={{ backgroundColor: "#ede7de" }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: htmlContentFamilySupport }}
            />
          </div>
          <div
            id="preservation"
            className="card category p-2 d-none"
            style={{ backgroundColor: "#ede7de" }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: htmlContentFamilyPreservation,
              }}
            />
          </div>
          <div
            id="reunification"
            className="card category p-2 d-none"
            style={{ backgroundColor: "#ede7de" }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: htmlContentFamilyReunification,
              }}
            />
          </div>
          <div
            id="permanency"
            className="card category p-2 d-none"
            style={{ backgroundColor: "#ede7de" }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: htmlContentAdoptionPromotion }}
            />
          </div>
          <ColoredLine color="#779442" />
        </div>
      </div>
    </>
  );
};

export default PssfYear;
